import { UPGRADE_NOTICE } from 'constants/UpgradeNotice';
import React, { useState } from 'react';

const formatPhoneHref = (phone) => {
    const digits = phone.replace(/\D/g, '');
    return digits ? `tel:${digits}` : '';
};

const UpgradeNoticeBanner = () => {
    const [isVisible, setIsVisible] = useState(true);

    if (!UPGRADE_NOTICE.enabled || !isVisible) {
        return null;
    }

    const phone_href = formatPhoneHref(UPGRADE_NOTICE.phone);

    return (
        <div className="upgrade-notice-banner" role="alert">
            <div className="upgrade-notice-banner__content">
                <strong>{UPGRADE_NOTICE.title}</strong>
                {' '}
                {UPGRADE_NOTICE.message}
                {' '}
                Email:
                {' '}
                <a href={`mailto:${UPGRADE_NOTICE.email}`}>{UPGRADE_NOTICE.email}</a>
                {' '}
                | Call:
                {' '}
                {phone_href ? (
                    <a href={phone_href}>{UPGRADE_NOTICE.phone}</a>
                ) : (
                    UPGRADE_NOTICE.phone
                )}
            </div>
            {/* <button
                type="button"
                className="upgrade-notice-banner__close"
                aria-label="Close"
                onClick={() => setIsVisible(false)}
            >
                &times;
            </button> */}
        </div>
    );
};

export default UpgradeNoticeBanner;
